const api = {
  addSaveEvent: (controlNumber) => `/case-event/${controlNumber}/save`,
};

export { api };
